import BulletList from '@tiptap/extension-bullet-list';
import OrderedList from '@tiptap/extension-ordered-list';
import { renderHTMLAttrs, TEMPLATE_VALUE_ATTRIBUTE } from './TemplateValue';
import { mergeAttributes } from '@tiptap/core';

export const CustomBulletList = BulletList.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			...TEMPLATE_VALUE_ATTRIBUTE,
			style: {
				default: null,
				parseHTML: (element) => element.getAttribute('style'),
				renderHTML: (attributes) => {
					if (!attributes.style) return {};
					return { style: attributes.style };
				},
			},
		};
	},
	renderHTML({ HTMLAttributes }) {
		return ['ul', mergeAttributes(renderHTMLAttrs({ HTMLAttributes, editor: this.editor })), 0];
	},
});

export const CustomOrderedList = OrderedList.extend({
	addAttributes() {
		return {
			...this.parent?.(),
			...TEMPLATE_VALUE_ATTRIBUTE,
			style: {
				default: null,
				parseHTML: (element) => element.getAttribute('style'),
				renderHTML: (attributes) => {
					if (!attributes.style) return {};
					return { style: attributes.style };
				},
			},
		};
	},
	renderHTML({ HTMLAttributes }) {
		return ['ol', mergeAttributes(renderHTMLAttrs({ HTMLAttributes, editor: this.editor })), 0];
	},
});
